<script>
export default {
	methods: {
		resetLifeStageAndCategories() {
			this.$store.commit('resetLifeStageData');
			this.$store.commit('resetCategories');
		}
	}
};
</script>
